import React from 'react';
import { styled } from '@linaria/react';
import { Text, TextAlign, TitleVariant } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
type AppExclusiveDealLabelProps = {
  variant?: TitleVariant;
  alignText?: TextAlign;
};
const _exp = /*#__PURE__*/() => Text;
const Label = /*#__PURE__*/styled(_exp())({
  name: "Label",
  class: "l1qe7fnk",
  propsAsIs: true
});
export const AppExclusiveDealLabel = ({
  variant = 'titleXS',
  alignText = 'start'
}: AppExclusiveDealLabelProps) => {
  return <Label variant={variant} colorPath="content.special.c600" align={alignText}>
      <FormattedMessageWrapper id="offer.vioAppExclusive" defaultMessage="Vio app exclusive" />
    </Label>;
};

require("./AppExclusiveDealLabel.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AppExclusiveDealLabel.tsx");